import { useEffect, useState } from 'react';
import type { MarketplaceProduct } from '@isbd/shared';
import { kuunda } from '@/lib/kuunda';
import { ProductCard } from './ProductCard';
import { normalizeProduct } from './normalize';

type Props = {
  sellerName: string;
  ownerId?: string | null;
  excludeId: string;
};

export function SellerProducts({ sellerName, ownerId, excludeId }: Props) {
  const [products, setProducts] = useState<MarketplaceProduct[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      setLoading(true);
      let query = kuunda
        .from('marketplace_products')
        .select('*')
        .eq('is_published', true)
        .order('created_at', { ascending: false })
        .limit(20);

      if (ownerId) {
        query = query.eq('owner_id', ownerId);
      } else if (sellerName) {
        query = query.eq('seller_name', sellerName);
      } else {
        if (!cancelled) {
          setProducts([]);
          setLoading(false);
        }
        return;
      }

      const { data, error } = await query;
      if (cancelled) return;
      if (error || !data) {
        setProducts([]);
      } else {
        setProducts(data.map(normalizeProduct).filter((p) => p.id !== excludeId));
      }
      setLoading(false);
    })();
    return () => {
      cancelled = true;
    };
  }, [sellerName, ownerId, excludeId]);

  if (!loading && products.length === 0) return null;

  return (
    <div className="mp-section">
      <div className="mp-seller-products-title">
        <h2>Autres produits de {sellerName}</h2>
      </div>
      {loading ? (
        <div className="mp-products">
          {Array.from({ length: 6 }).map((_, i) => (
            <div key={i} className="mp-skeleton">
              <div className="mp-skeleton-media" />
            </div>
          ))}
        </div>
      ) : (
        <div className="mp-products">
          {products.map((p) => (
            <ProductCard key={p.id} product={p} />
          ))}
        </div>
      )}
    </div>
  );
}
